module.exports = __webpack_public_path__ + "static/media/ad_phone.d3400f2e.png";